import { render, staticRenderFns } from "./Controls.vue?vue&type=template&id=0d5bb9e2"
import script from "./Controls.vue?vue&type=script&lang=js"
export * from "./Controls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports